import { validateNovelGame } from './validate';
import type { NovelGenerateInput, NovelGenerateResult } from './types';

export class NovelApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NovelApiError';
  }
}

/** 生成はサーバー1回のみ。プレイ中は呼ばない。 */
export async function generateNovelGame(input: NovelGenerateInput): Promise<NovelGenerateResult> {
  let res: Response;
  try {
    res = await fetch('/api/ai/novel/generate', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(input),
    });
  } catch {
    throw new NovelApiError('ネットワークエラーが発生しました。接続を確認してください。');
  }

  let body: unknown = null;
  try {
    body = await res.json();
  } catch {
    body = null;
  }

  if (!res.ok) {
    const code = (body as { code?: string } | null)?.code;
    if (res.status === 401) throw new NovelApiError('サインインが必要です。');
    if (code === 'ai_not_configured' || res.status === 503) {
      // サーバーがフォールバックを返さない場合のみ
      throw new NovelApiError('ゲームの生成に失敗しました。しばらくしてからもう一度お試しください。');
    }
    throw new NovelApiError('ゲームの生成に失敗しました。しばらくしてからもう一度お試しください。');
  }

  const data = body as {
    game?: unknown;
    source?: 'llm' | 'azure-openai' | 'fallback';
    usage?: NovelGenerateResult['usage'];
  } | null;

  if (!data?.game) {
    throw new NovelApiError('ゲームの生成に失敗しました。しばらくしてからもう一度お試しください。');
  }

  try {
    const game = validateNovelGame(data.game);
    return {
      game,
      source: data.source === 'fallback' ? 'fallback' : 'llm',
      usage: data.usage,
    };
  } catch {
    throw new NovelApiError('ゲームの生成に失敗しました。しばらくしてからもう一度お試しください。');
  }
}
